<div>
    <!--   <h1 class="pageHeader">Power BI Report</h1> -->

    <div class="claim-filter-section">

        <div class="bottomMargin" [appIsLoading]="loadingService.isLoading(this)">

            <!--  <button class="btn btn-primary" (click)="showReport()">clickme</button> -->
            <!--  <iframe src="this.embedContainer" title="description" width="100%" height="500px"></iframe> -->
            <!--  <div style=" width: 100%;" [ngStyle]="{ 'height': (screenHeight-150)+ 'px' }" #reportContainer></div>  -->

            <div id="reportContainer" style="height:90vh;"></div>
        </div>
    </div>
</div>